import React, { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../service/context";
import { useSelector } from "react-redux";

function Breadcrumbs() {
  const location = useLocation().pathname.toString();
  const currentPath = location.split("/").slice(1);
  const navigate = useNavigate();

  const { performancedata } = useSelector((state) => state.todoPerformance);
  const salesOrder = useSelector(state => state.salesOrder);
  const purchaseOrder = useSelector(state => state.purchaseOrder);
  const { previous_path } = useSelector((state) => state.path);

  const ctx = useContext(UserContext);

  if (currentPath[0] === "" || currentPath[0] === "calendar") {
    currentPath[0] = "Overview";
  } else if(currentPath[0] === "customization"){
    currentPath[0] = "White Labeling"
  } else if (currentPath.includes("design")) {
    currentPath.splice(0, 2, "Manage Template");
    if (currentPath.includes("overview")) {
      currentPath.pop();
    }
  } else if (currentPath.includes("configuration")) {
    currentPath[0] = "Manage Workflows";
    if (currentPath.includes("overview")) {
      currentPath.pop();
    }
    if (currentPath.includes("view") || currentPath.includes("update")) {
      currentPath.pop();
    }
  } else if (
    currentPath.includes("activity") &&
    !currentPath.includes("performance")
  ) {
    currentPath[0] = "Manage To Dos";
    if (currentPath.includes("overview")) {
      currentPath.pop();
    }
  } else if (currentPath.includes("booking")) {
    currentPath[0] = "Bookings";
    if (currentPath.includes("overview")) {
      currentPath.pop();
    }
  } else if (currentPath.includes("assignment")) {
    currentPath[0] = "Bookings";
    currentPath[1] = "Assignment";
    currentPath.pop();
  } else if (
    currentPath.includes("performance") &&
    currentPath.includes("todo")
  ) {
    if(previous_path === "/booking/overview") {
      currentPath[0] = "Bookings";
      currentPath[1] = performancedata?.internal_booking_ref_id;
      currentPath.pop()
    } else if(previous_path.includes("/assignment/assign")) {
      currentPath[0] = "Bookings";
      currentPath[1] = "Assignment";
      currentPath[2] = performancedata?.internal_booking_ref_id;
      // currentPath.pop()
    } else if(previous_path === "/") {
      currentPath[0] = "Overview";
      currentPath[1] = performancedata?.internal_booking_ref_id;
      currentPath.pop()
    } else if(previous_path === "/purchase_order") {
      currentPath[0] = "Order";
      currentPath[1] = "Purchase Order";
      currentPath[2] = performancedata?.internal_booking_ref_id;
      if(performancedata?.alias) {
        currentPath[3] = performancedata?.alias
      }
    } else if(previous_path === "/sales_order") {
      currentPath[0] = "Order";
      currentPath[1] = "Sales Order";
      currentPath[2] = performancedata?.internal_booking_ref_id;
      if(performancedata?.alias) {
        currentPath[3] = performancedata?.alias
      }
    }
  } else if (currentPath.includes("departments")) {
    currentPath[0] = "Teams";
  } else if (
    currentPath.includes("requests") &&
    currentPath.includes("overview")
  ) {
    currentPath.pop();
  } else if (currentPath.includes("insights")) {
    currentPath[0] = "Analytics";
  } else if (currentPath.includes("billingdetails")) {
    currentPath[0] = "Billing & Plan Details";
  } else if (currentPath.includes("component")) {
    currentPath[0] = "Manage Components";
  } else if (currentPath.includes("sku")) {
    currentPath[0] = "SKU Master";
  } else if (currentPath[0].includes("product")) {
    currentPath[0] = "Product Master";
  }

  if (currentPath.includes("create_sales_order")) {
    currentPath[1] = salesOrder?.headerValue ? salesOrder.headerValue : "Create Sales Order";
  } else if (currentPath.includes("update_sales_order")) {
    currentPath[1] = salesOrder?.headerValue ? salesOrder.headerValue : "Update Sales Order";
  } else if (currentPath.includes("create_purchase_order")) {
    currentPath[1] = purchaseOrder?.headerValue ? purchaseOrder.headerValue : "Create Purchase Order";
  } else if (currentPath.includes("update_purchase_order")) {
    currentPath[1] = purchaseOrder?.headerValue ? purchaseOrder.headerValue : "Update Purchase Order";
  } else if (currentPath.includes("create_production_order")) {
    currentPath[1] = "Create Production Order";
  } else if (currentPath.includes("update_production_order")) {
    currentPath[1] = "Update Production Order";
  }

  const navigateByClickOnHome = () => {
    if (ctx.user?.type !== "user" && ctx.user?.type !== "admin") {
      navigate("/booking/overview");
    } else {
      navigate("/");
    }
  };

  const navigateByClickOnOther = (index) => {
    switch (index) {
      case 0:
        if (currentPath[index] === "Bookings") {
          navigate("/booking/overview");
        } else if (currentPath[index] === "Overview") {
          navigate("/");
        } else if (currentPath[index] === "Manage To Dos") {
          navigate("/activity/overview");
        // } else if (currentPath[index] === "Manage Workflows") {
        } else if (currentPath[index] === "workflows") {
          navigate("/workflows");
        } else if (currentPath[index] === "Manage Template") {
          navigate("/booking/design/overview");
        } else if (currentPath[index] === "Manage Components") {
          navigate("/component/create");
        } else if (currentPath[index] === "SKU Master") {
          navigate("/sku/overview");
        } else if (currentPath[index] === "Product Master") {
          navigate("/product/overview");
        } else if(currentPath[index] === "Order") {
          navigate("/order/overview", {state: 1})
        }
        break;

      case 1: 
        if(currentPath[index] === "Purchase Order") {
          navigate("/order/overview", {state: 2})
        } else if(currentPath[index] === "Sales Order") {
          navigate("/order/overview", {state: 1})
        }
        break;

      case 2: 
        if(currentPath[index].includes("PO")) {
          navigate("/order/overview", {state: 2})
        } else if(currentPath[index].includes("SO")) {
          navigate("/order/overview", {state: 1} )
        }
        break;  

      default:
        break;
    }
  };

  return (
    <nav className="flex pt-1" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-4">
        <li>
          <div>
            <a
              className={`text-gray-400 hover:text-[--bg-color-600] cursor-pointer`}
              onClick={navigateByClickOnHome}
            >
              <span className="fas fa-home-lg-alt text-sm" />
            </a>
          </div>
        </li>
        {currentPath.map((page, index) => (
          <li key={index}>
            <div className="flex items-center">
              <span className="fas fa-chevron-right text-xs" />
              <a
                className={`ml-4 text-sm capitalize font-medium cursor-pointer ${
                  index === currentPath.length - 1
                    ? "text-[--bg-color-500]"
                    : "text-gray-500"
                } hover:text-[--bg-color-600]`}
                onClick={() => navigateByClickOnOther(index)}
              >
                {page}
              </a>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
